import { Button, Select, Table, Typography, Pagination, Input } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useLoaderData } from 'react-router-dom'

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Customer',
    dataIndex: 'customer',
    key: 'customer',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Reference',
    dataIndex: 'reference',
    key: 'reference',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Debit',
    dataIndex: 'debit',
    key: 'debit',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    render: (_, record) => <span>{record.debit.$numberDecimal}</span>
  },
  {
    title: 'Credit',
    dataIndex: 'credit',
    key: 'credit',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    render: (_, record) => <span>{record.credit.$numberDecimal}</span>
  },
  {
    title: 'Balance',
    dataIndex: 'balance',
    key: 'balance',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    render: (_, record) => <span>{record.credit.$numberDecimal - record.debit.$numberDecimal}</span>
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/accounting/analytic-accounts/'+record.seo}>
        EDIT
      </Link>
    )
  }
]

const options = []
for (let i = 10; i < 36; i++) {
  options.push({
    value: i.toString(36) + i,
    label: i.toString(36) + i
  })
}
const handleChange = (value) => {
  console.log(`Selected: ${value}`)
}

const AnalyticAccounts = () => {
  const analyticAccounts = useLoaderData()
  const [current, setCurrent] = useState(3)
  const onChange = (page) => {
    console.log(page)
    setCurrent(page)
  }

  
  // accounts.forEach((_, idx) => (accounts[idx]['key'] = idx))

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Analytic Accounts</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            onChange={handleChange}
            className='w-96'
            options={options}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/accounting/analytic-accounts/new'} className='w-full'>
              New
            </Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination current={current} onChange={onChange} total={50} />
          </div>
        </div>
      </div>
      <Table
        dataSource={analyticAccounts}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'name'}
      />
    </div>
  )
}

export default AnalyticAccounts;
